export const handleImgNotFoundError = (): never => {
  throw new Error('Image not found')
}
